import { ref } from '@vue/composition-api'

export const loadingSpinner = ref(false)
